export default "__VITE_ASSET__CoZTT8p6__"